import { createLucideIcon } from "lucide-react";

export const PlusMinusSquare = createLucideIcon(
    "PlusMinusSquare",
    [
        [
            "path",
            {
                d: "M1.66797 8.00008C1.66797 5.01452 1.66797 3.52174 2.59546 2.59424C3.52296 1.66675 5.01574 1.66675 8.0013 1.66675C10.9869 1.66675 12.4796 1.66675 13.4071 2.59424C14.3346 3.52174 14.3346 5.01452 14.3346 8.00008C14.3346 10.9856 14.3346 12.4784 13.4071 13.4059C12.4796 14.3334 10.9869 14.3334 8.0013 14.3334C5.01574 14.3334 3.52296 14.3334 2.59546 13.4059C1.66797 12.4784 1.66797 10.9856 1.66797 8.00008Z",
                key: "n31yj1",
            },
        ],
        [
            "path",
            {
                d: "M10.0013 10.0001L11.3346 10.0001",
                key: "slwgq",
            },
        ],
        [
            "path",
            {
                d: "M10.0013 10.0001L8.668 10.0001",
                key: "1y28nf",
            },
        ],
        [
            "path",
            {
                d: "M10.0013 10.0001V8.6668",
                key: "x4rdne",
            },
        ],
        [
            "path",
            {
                d: "M10.0013 11.3334L10.0013 10.0001",
                key: "twtlo",
            },
        ],
        [
            "path",
            {
                d: "M11.3346 4.6668L4.668 11.3334",
                key: "j4x2i0",
            },
        ],
        [
            "path",
            {
                d: "M4.668 6.0001L7.3346 6.0001",
                key: "14k4j6",
            },
        ],
    ],
);
